import React from 'react';
import AppLayout, { AppLayoutProps } from '@cloudscape-design/components/app-layout';
import TopNavigation from '@cloudscape-design/components/top-navigation';
import Box from "@cloudscape-design/components/box";
import SpaceBetween from "@cloudscape-design/components/space-between";
import Link from "@cloudscape-design/components/link";
import {
  Alert,
  Button,
  Container,
  ContentLayout,
  Header,
  Input,
} from "@cloudscape-design/components";
import './styles.css';
import logo from '../../logo.png';

function Footer() {
  return (
    <div style={{ backgroundColor: '#ffffff', color: 'white' }}>
      <Box margin={{ top: "l" }} padding="l" textAlign="center" color="text-status-inactive" >
        <SpaceBetween size="xs" direction="vertical">
          <Box 
            variant="p"
            fontSize="body-s"
            color="inherit"
          >
            AI findings show the completeness and clarity of the applications and do not provide any judgment. 
            The application will be evaluated and Judged by the Institutional Listing Panel.
          </Box>
          <Box 
            variant="p"
            fontSize="body-s"
            color="inherit"
          >
              BQA Self-Assessment Portal
          </Box>
        </SpaceBetween>
      </Box>
    </div>
  );
}


export interface ShellProps {
  breadcrumbs?: AppLayoutProps['breadcrumbs'];
  contentType?: Extract<AppLayoutProps.ContentType, 'default' | 'table' | 'form'>;
  tools?: AppLayoutProps['tools'];
  children?: AppLayoutProps['content'];
  navigation?: AppLayoutProps['navigation'];
  notifications?: AppLayoutProps['notifications'];
}

export default function Shell({ children, contentType, breadcrumbs, tools, navigation, notifications }: ShellProps) {
  return (
    <>
      <div 
        style={{
          padding: '20px',
          borderBottom: '3px solid #1C4679',
          backgroundColor: '#ffffff'
        }}
      >
        <h1 style={{ 
          fontWeight: 600,
          margin: 0,
          color: '#1C4679',
          textAlign: 'left'
        }}>
          <img 
            src={logo}
            alt="BQA Logo"
            style={{
              maxWidth: '200px',
              height: 'auto',
              display: 'block'
            }}
          />
        </h1>
      </div>

      <AppLayout
        contentType={contentType}
        navigation={navigation}
        breadcrumbs={breadcrumbs}
        notifications={notifications}
        stickyNotifications={true}
        tools={tools}
        content={children}
        headerSelector="#top-nav"
        ariaLabels={{
          navigation: 'Navigation drawer',
          navigationClose: 'Close navigation drawer',
          navigationToggle: 'Open navigation drawer',
          notifications: 'Notifications',
          tools: 'Help panel',
          toolsClose: 'Close help panel',
          toolsToggle: 'Open help panel',
        }}
      />
      <Footer />
    </>
  );
}